import { FundingSourceType } from "@wingspanhq/payments/dist/interfaces";
import { MethodType } from "../../modules/Settings/components/ManageMethods/types";
import { FUNDING_SOURCE_TYPE_STRIPE_PAYMENT_CARD } from "../constants/fundingSource";

/**
 * Maps a payroll funding source type to the payment method type the app renders and
 * manages methods by.
 *
 * The mapping is not an identity even where the names match: `FundingSourceType.PaymentCard`
 * and `FUNDING_SOURCE_TYPE_STRIPE_PAYMENT_CARD` both hold a Stripe paymentMethod id
 * (`pm_…`) resolved from `client.profile.savedPaymentMethods`, which is the `CreditCard`
 * method type. The `PaymentCard` method type is a different entity - a Footprint card
 * fetched from `/payments/payment-card/:id` - and resolving a Stripe card as one returns
 * a 404.
 *
 * Returns `undefined` for funding source types the app doesn't know how to render, so
 * callers can fall back to an empty state instead of rendering the wrong method.
 */
export const selectorFundingSourceMethodType = (
  fundingSourceType: FundingSourceType
): MethodType | undefined => {
  switch (fundingSourceType) {
    case FundingSourceType.Account:
      return "Account";

    case FundingSourceType.InternalAccount:
      return "InternalAccount";

    case FundingSourceType.PaymentCard:
    case FUNDING_SOURCE_TYPE_STRIPE_PAYMENT_CARD:
      return "CreditCard";

    default:
      return undefined;
  }
};
